<template>
  <header>
    <div class="logo"><router-link to="/"><img src="@/assets/img/common/logo.svg" alt="advision"></router-link></div>
    <menu-button></menu-button>
    <global-nav></global-nav>
  </header>
</template>

<script>
import MenuButton from '@/components/MenuButton'
import GlobalNav from '@/components/GlobalNav'
export default {
  components: {
    MenuButton,
    GlobalNav
  },
}
</script>

<style lang="scss">
header {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 80px;
  background-color: white;
  z-index: 1000;
  .logo {
    position: absolute;
    top: calc(50% - 15px);
    left: 30px;
    width: 126px;
    @include imgfit;
  }
  @include mq {
    height: 60px;
    .logo {
      left: 15px;
    }
  }
}
</style>